

class MessageParser {
    constructor(actionProvider, state) {
      this.actionProvider = actionProvider;
      this.state = state;
    }
  
    parse(userMessage) {
     

      
        const lowercase = userMessage.toLowerCase();
        let matched = false;

        if (lowercase.includes('hello') || lowercase.includes('hi') || lowercase.includes('hey')){
          this.actionProvider.greet();
          matched = true;
        }
        if (lowercase.includes('flight status')){
          this.actionProvider.handleFlightStatus();
          matched = true;
        }
        if (lowercase.includes('book') || lowercase.includes('trip')){
          this.actionProvider.handleBookATrip();
          matched = true;
        }
        if (lowercase.includes('hotel')){
          this.actionProvider.handleFindHotels();
          matched = true;
        }
        if (lowercase.includes('packing') || lowercase.includes('tips') ){
          this.actionProvider.handlePackingTips();
          matched = true;
        }
        if (lowercase.includes('vacation') || lowercase.includes('spots') ){
          this.actionProvider.handleVacationSpots();
          matched = true;
        }
        if (lowercase.includes('flight deals') || lowercase.includes('deals') ){
          this.actionProvider.handleFlightDeals();
          matched = true;
        }
        if (lowercase.includes('register') || lowercase.includes('sign') ){
          this.actionProvider.handleRegister();
          matched = true;
        }
        if (lowercase.includes('vehicle') || lowercase.includes('rent' )){
          this.actionProvider.handleVehicleRentals();
          matched = true;
        }
        if (lowercase.includes('agent') || lowercase.includes('care' ) || lowercase.includes('customer' )){
          this.actionProvider.handleDirectToAgent();
          matched = true;
        } if (!matched) {
          this.actionProvider.handleDefaultResponse();
      }
    }
  }
  
  export default MessageParser;